import { NotificationCard } from '../models/notification-card';
import * as braze from '@braze/web-sdk';

export const mapContentCardsToNotificationCards = (
  contentCards: braze.Card[]
) => {
  const notificationCards: NotificationCard[] = [];
  contentCards.forEach((card) => {
    if (card instanceof braze.ClassicCard) {
      notificationCards.push(
        new NotificationCard(card.id ?? null, card.title, card.description, {
          color: card.extras['color'],
          imageUrl: card.imageUrl,
          linkText: card.linkText,
          url: card.url,
        })
      );
    }
  });
  return notificationCards;
};
